type SiteKeySources = {
  scriptKey?: string
  urlKey?: string
  defaultKey?: string
  storedKey?: string | null
}

// Hotels embed the widget with the key under several spellings: ?site-key=, ?SiteKey= and, on live
// sites such as pih.ir and esteghlalhotel.ir, ?sitekey=. Release 4.0 started reading only the first
// two, so those sites lost their key. Match the name ignoring case and the hyphen.
const SITE_KEY_PARAM = /^site-?key$/i

export function siteKeyFromScriptSrc(src: string, baseHref: string): string {
  if (!src) return ''
  try {
    const params = new URL(src, baseHref).searchParams
    for (const [name, value] of Array.from(params.entries())) {
      if (SITE_KEY_PARAM.test(name) && value) return value
    }
    return ''
  } catch {
    return ''
  }
}

// The embed script is normally tagged id="adlSearchBoxScript", but hosts that inject it (Next.js
// <Script>, tag managers) may drop the id. Fall back to Adotel's embed.js, anchored on the host so
// another vendor's /embed/embed.js on the same page is never picked up.
export function findEmbedScript(doc: Document): HTMLScriptElement | null {
  return (
    (doc.getElementById('adlSearchBoxScript') as HTMLScriptElement | null) ||
    doc.querySelector<HTMLScriptElement>(
      'script[src*="adotel.net/embed/embed.js"]'
    )
  )
}

export function resolveSiteKey({
  scriptKey,
  urlKey,
  defaultKey,
  storedKey
}: SiteKeySources): string {
  return scriptKey || urlKey || defaultKey || storedKey || ''
}
